export default "__VITE_ASSET__Bj6V9T1m__"